<template>
    <div class="card-body">
        <b-row v-if="! token">
            <b-col cols="12">
                <ul>
                    <li>El token será válido durante un año desde el día en que se genera</li>
                    <li>Si se genera un nuevo token, los anteriores dejarán de funcionar</li>
                    <li>El token solo se mostrará en el momento en el que se genera, si se pierde habrá que crear un nuevo token y los anteriores dejarán de funcionar</li>
                </ul>
            </b-col>   
            <b-col cols="12">
                <b-button block v-b-modal.confirmar>Generar nuevo token</b-button>
                <b-modal 
                    id="confirmar" 
                    title="¿Seguro que quiere generar un nuevo token?"
                    @ok="getToken()"
                >
                    <b-row>
                        <b-col cols="12">
                            <b-alert show variant="danger">
                                Sí genera un nuevo token los emitidos anteriormente dejarán de funcionar
                            </b-alert>
                        </b-col>
                    </b-row>
                </b-modal>
            </b-col>
        </b-row>
        <b-row v-else>
            <b-col cols="12">
                <h3>Nuevo token:</h3>
            </b-col>
            <b-col cols="12">
                <b-card>
                    <b-card-text>
                        {{ token }}
                    </b-card-text>
                </b-card>
            </b-col>
            <b-col cols="12">
                <b-button class="mb-3" block @click="copiarToken()">Copiar al portapapeles</b-button>
            </b-col>
            <b-col cols="12">
                <b-alert show variant="info">
                    <h4>Copie el token y guardelo en un lugar seguro, una vez que actualice la página no podrá volver a consultarlo y tendrá que generar uno nuevo</h4>
                </b-alert>
            </b-col>
        </b-row>
    </div>
</template>

<script>

    export default {
        data() {
            return {
                token: null
            }
        },
        methods: {
            getToken() {
                this.$store.dispatch(this.config.getVuexAlias('back.teatro.token'), { filters: {} }).then(res => {
                    this.token = res.data.token;
                });
            },
            copiarToken() {
                navigator.clipboard.writeText(this.token);
            }
        }
    }
</script>